/*!
 *
 * Angle - Bootstrap Admin Template
 *
 * Version: 4.8.1
 * Author: @themicon_co
 * Website: http://themicon.co
 * License: https://wrapbootstrap.com/help/licenses
 *
 */

import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';

// App Routes
import Routes from './Routes';

// Vendor dependencies
import "./Vendor";
// Application Styles
import './styles/bootstrap.scss';
import './styles/app.scss'
import './styles/custom/mobile980.css';
import './styles/custom/general.css'
import config from './helper/Config';
import { convertBaseURL } from './helper/FileManager';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types'
import * as actions from "./store/actions/actions";
import { getAppMenu, getDataTable, getVersion } from './helper/Service';
import Spinner from './components/Elements/Spinner';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  fetchAppSetting = async () => {
    let param = {
      "Take": 9999,
      "filters": [
        {
          "ColumnName": "AppSettingKeys",
          "ColumnValue": 'FileManagerURL,default_TakePerRow',
          "Operator": "EQ"
        }
      ]
    };

    try {
      const response = await getDataTable(param, 'SP_Multiple_Appsetting');
      if (response.resultCode == 200) {
        let data = response.data[0];
        let defaultTake = data.default_TakePerRow? data.default_TakePerRow : "10";
        this.props.actions.setOriginalFileManagerUrl(data.fileManagerURL);
        this.props.actions.setFileManagerUrl(convertBaseURL(data.fileManagerURL));
        this.props.actions.setDefaultTakePerRow(parseInt(defaultTake));
      }
    } catch (error) {
      console.log(error)
    }
  };

  fetchPaymentProvider = async () => {
    let param = {
      "Take": 9999,
      "filters": [
        {
          "ColumnName": "AppSettingKeys",
          "ColumnValue": 'PAYMENTPROVIDER_URL',
          "Operator": "EQ"
        }
      ]
    };

    try {
      const response = await getDataTable(param, 'SP_Multiple_Appsetting');
      if (response.resultCode == 200) {
        let data = response.data[0];
        console.log(data);
        this.props.actions.setPaymentProvider(data.pAYMENTPROVIDER_URL);
        // this.props.actions.setFileManagerUrl(convertBaseURL(data.fileManagerURL));
      }
    } catch (error) {
      console.log(error)
    }
  }

  fetchMenu = async () => {
    let response = await getAppMenu('setup');
    if (response?.status == 200) {
      let data = response.data;

      let menu = [];
      // create menu object
      for (var i = 0; i < data.length; i++) {
        if (data[i].items.length < 1) continue;
        if (!data[i].ableToView) continue;

        let submenu = []

        for (var j = 0; j < data[i].items.length; j++) {
          if (!data[i].items[j].ableToView) continue;

          submenu.push({
            id: data[i].items[j].appMenuID,
            name: data[i].items[j].menuText,
            path: `/${data[i].items[j].route}`,
            ableToView: data[i].items[j].ableToView,
            ableToEdit: data[i].items[j].ableToEdit,
            ableToDelete: data[i].items[j].ableToDelete,
            ableToSetTable: data[i].items[j].ableToSetTable,
            exportProcedure: data[i].items[j].exportProcedure
          })
        }

        menu.push({
          id: data[i].appMenuID,
          name: data[i].menuText,
          icon: data[i].icon,
          submenu: submenu
        })
      }

      this.props.actions.listMenuPrivilege(menu);
      this.setState({
        loading: false
      })
    }
  };

  fetchVersion = async () => {
    let response = await getVersion('setup');

    if (response?.resultCode == 200)
      this.props.actions.setVersion(response.data?.apiVersion);
    this.props.actions.setAPIBuildNumber(response.data?.buildNumber);
  };

  componentDidMount = () => {
    this.fetchVersion();
    if (Object.keys(this.props.user.userInfo).length > 0) {
      this.fetchMenu()
      this.fetchAppSetting();
      this.fetchPaymentProvider();
    } else {
      this.setState({ loading: false })
    }
  }


  render() {
    return (
      this.state.loading ? <Spinner /> :
        <BrowserRouter basename={`/${config.BASE_URL}`}>
          <Routes user={this.props.user} />
        </BrowserRouter>
    );

  }
}


App.propTypes = {
  user: PropTypes.object,
  actions: PropTypes.object
}

const mapStateToProps = state => ({ user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps, mapDispatchToProps
)(App);
